<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  count: number;
  kind: 'mark' | 'action';
}>();

const totalActions = 10;

const progressPercent = computed(() => {
  return Math.min((props.count / totalActions) * 100, 100);
});

const isCompleted = computed(() => props.count >= totalActions);

const message = computed(() => {
  if (props.count === 0) {
    return '';
  }
  if (isCompleted.value) {
    return '完了！興味にピッタリな記事が毎日届きます';
  }
  if (props.count < 5) {
    return `あと${totalActions - props.count}件で、記事が届き始めます！`;
  }
  return `もう少し！あと${totalActions - props.count}件で完了です`;
});

const actionLabel = computed(() => {
  return props.kind === 'mark' ? 'マーク' : 'アクション';
});

const subMessage = computed(() => {
  if (isCompleted.value) {
    return '記事にアクションを続けることで、レコメンドの精度が向上していきます';
  }
  return '';
});
</script>

<template>
  <div class="action-progress">
    <div class="action-count c-title-bold--m">
      {{ count }}/{{ totalActions }} {{ actionLabel }}済み
    </div>
    <div class="progress-bar">
      <div
        class="progress-fill"
        :style="{ width: `${progressPercent}%` }"
      ></div>
    </div>
    <div v-if="message" class="message c-text-regular--m">
      {{ message }}
    </div>
    <div v-if="subMessage" class="sub-message c-text-regular--m">
      {{ subMessage }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.action-progress {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-count {
  color: $color-gray1000;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: $color-gray400;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: $color-green600;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.message {
  color: $color-gray800;
}

.sub-message {
  color: $color-green600;
}
</style>
